module.exports = __webpack_public_path__ + "img/excel.0721ed32.png";